/** @format */

const template = `
<sis-search-filter-options-menu
  [search-parameter-options]="$ctrl.searchParameterOptions"
  [search-parameter-titles]="$ctrl.searchParameterTitles"
  [search-params]="$ctrl.searchParams"
  [disable]="$ctrl.disable"
  [main-button-key]="$ctrl.mainButtonKey"
  [university]="$ctrl.university"
  [scope]="$ctrl.$scope"
  (search-again)="$ctrl.searchAgain()"
  (selected)="$ctrl.onSelect($event)">
</sis-search-filter-options-menu>
`;
export default template;
